"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_router_dom_1 = require("react-router-dom");
var reactstrap_1 = require("reactstrap");
var FontAwesomeIcon_1 = require("./../../FontAwesomeIcon");
var Card = /** @class */ (function (_super) {
    __extends(Card, _super);
    function Card() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Card.prototype.renderIcon = function () {
        var _a = this.props, iconName = _a.iconName, color = _a.color;
        return React.createElement(FontAwesomeIcon_1.default, { icon: iconName, size: "2x", className: "bg-".concat(color || "primary", " text-white shadow-d1 p-4 mt--5") });
    };
    Card.prototype.render = function () {
        var _a = this.props, link = _a.link, children = _a.children, color = _a.color, headerContent = _a.headerContent;
        return (React.createElement("div", { className: "pt-4 pb-3 h-100" },
            React.createElement(reactstrap_1.Card, { className: "h-100" },
                React.createElement(reactstrap_1.CardBody, null,
                    React.createElement("div", { className: "clearfix" },
                        link ? (React.createElement(react_router_dom_1.Link, { to: link }, this.renderIcon())) : this.renderIcon(),
                        React.createElement("div", { className: "float-right text-right" }, headerContent)),
                    React.createElement("hr", { className: "bg-".concat(color || "primary") }),
                    React.createElement(reactstrap_1.CardText, { tag: "div" }, children)))));
    };
    return Card;
}(React.Component));
exports.default = Card;
//# sourceMappingURL=Card.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/@athena-portal/components/dist/theme/mdb/Card.js
// module id = 2259
// module chunks = 0